export default function isUserProductGroupNameValid(name: string): boolean {
	return Array.from(name).length >= 3;
}
